module.exports = __webpack_public_path__ + "img/cx_vacina_astrazeneca.e0758353.webp";